// import img2kolor from '../images/ankietabg/2kolor.jpg';
// import img3wytra from '../images/ankietabg/3wytrawne.jpg';
// import img4cena from '../images/ankietabg/4cena.jpg';
// import img5okazja from '../images/ankietabg/5okazja.jpg';
// import img6kraj from '../images/ankietabg/6kraj.jpg';

export interface Question {
  id: number;
  title: string;
  bgImg: string;
  answers: AnswerItem[];
}
export interface AnswerItem {
  answer: string;
  eanCodeList: string[];
}

export async function getDatabase() {
  const data: Question[] = await fetch('/api/v1/pollsystem_db').then((r) => r.json());
  return data;
}

/*
export const database: Question[] = [
  {
    id: 1,
    title: 'Kolor',
    bgImg: img2kolor,
    answers: [
      {
        answer: 'Białe',
        eanCodeList: [
          '8410744011934',
          '8410744011965',
          '3113934001337',
          '3249381042798',
          '3249381096302',
          '3258691236339',
          '3263280113762',
          '3308440053943',
          '3800007819202',
          '3800008165940',
          '3800008911226',
          '3800008919437',
          '4006542071337',
          '4006542073430',
          '4008005041697',
          '4008005630020',
          '4014984016717',
          '4036505060443',
          '4049366002927',
          '4049366003207',
          '4049366003290',
          '4049366003764',
          '4840472011281',
          '4840472019126',
          '4860004070227',
          '4860038075304',
          '4860038075502',
          '5010134909518',
          '5010134916714',
          '5010134919142',
          '5601377001581',
          '5601377001789',
          '5601954000709',
          '5602445005500',
          '5908235955063',
          '5997830309326',
          '5998288509290',
          '5999074603666',
          '5999074609651',
          '7804462002281',
          '8003625011262',
          '8003625013051',
          '8003625020325',
          '8003625027515',
          '8003625041757',
          '8003625073161',
          '8003625080664',
          '8003625091516',
          '8034041270100',
          '8034115190006',
          '8034115192925',
          '8410261703206',
          '8410744011590',
          '8411277205654',
          '8411277205678',
          '9311043032615',
          '9311043081132',
        ],
      },
      {
        answer: 'Czerwone',
        eanCodeList: [
          '8410744011934',
          '8410744011965',
          '3249381004970',
          '3249381050052',
          '3258691612430',
          '3263286350185',
          '3294381042026',
          '3308440023380',
          '3308440053950',
          '3500610137518',
          '3800007817444',
          '3800007819219',
          '3800008911325',
          '3800008925285',
          '3800011414769',
          '3800011414820',
          '4006542073447',
          '4049366003788',
          '4840472011274',
          '4840472019119',
          '4840472020498',
          '4860004070173',
          '4860004073365',
          '4860038075441',
          '4860038075601',
          '5010134916684',
          '5010134917377',
          '5010134919128',
          '5010134919135',
          '5600320460369',
          '5601250102213',
          '5601317007796',
          '5601377001574',
          '5601377002717',
          '5602418000136',
          '5901617013177',
          '5902241705865',
          '5908235955049',
          '5999074603642',
          '5999074609804',
          '7804462002250',
          '8003625000518',
          '8003625000907',
          '8003625001812',
          '8003625003601',
          '8003625005612',
          '8003625014836',
          '8003625021056',
          '8003625029243',
          '8003625033080',
          '8003625048596',
          '8003625081470',
          '8003625082583',
          '8003625094029',
          '8007425000471',
          '8007425200017',
          '8034115191065',
          '8034115194066',
          '8410261141039',
          '8410261701202',
          '8410702032452',
          '8410744006510',
          '8410744008675',
          '8410744010289',
          '9311043013584',
          '9311043067549',
        ],
      },
      {
        answer: 'Różowe',
        eanCodeList: [
          '8410744011934',
          '8410744011965',
          '3263280102414',
          '4840472020900',
          '5028267006943',
          '5902241712504',
          '5902241712528',
          '5999074609439',
          '8003625011255',
          '8003625017042',
          '8003625026082',
          '8006063003233',
        ],
      },
    ],
  },
  {
    id: 2,
    title: 'Wytrawność',
    bgImg: img3wytra,
    answers: [
      {
        answer: 'Wytrawne',
        eanCodeList: [
          '3113934001337',
          '3249381004970',
          '3249381096302',
          '3258691236339',
          '3258691612430',
          '3308440023380',
          '3500610137518',
          '3800008165940',
          '3800008911226',
          '3800008911325',
          '3800008919437',
          '3800008925285',
          '4006542071337',
          '4008005630020',
          '4049366003207',
          '4049366003764',
          '4049366003788',
          '4840472019119',
          '4840472019126',
          '4840472020900',
          '4860038075441',
          '4860038075502',
          '5010134917377',
          '5601250102213',
          '5601377001574',
          '5601377001581',
          '5998288509290',
          '5999074603642',
          '5999074609804',
          '7804462002250',
          '7804462002281',
          '8003625000518',
          '8003625000907',
          '8003625001812',
          '8003625003601',
          '8003625005612',
          '8003625011255',
          '8003625013051',
          '8003625014836',
          '8003625020325',
          '8003625021056',
          '8003625027515',
          '8003625033080',
          '8003625041757',
          '8003625048596',
          '8003625080664',
          '8003625094029',
          '8007425000471',
          '8007425200017',
          '8034041270100',
          '8034115190006',
          '8034115192925',
          '8034115194066',
          '8410261141039',
          '8410744006510',
          '8410744010289',
          '8411277205654',
          '9311043013584',
          '9311043032615',
          '9311043067549',
          '9311043081132',
        ],
      },
      {
        answer: 'Półwytrawne',
        eanCodeList: [
          '3249381042798',
          '3249381050052',
          '3308440053943',
          '3308440053950',
          '3800011414820',
          '4006542073430',
          '4008005041697',
          '4014984016717',
          '4036505060443',
          '4860004073365',
          '4860038075304',
          '4860038075601',
          '5010134909518',
          '5010134916684',
          '5010134916714',
          '5010134919128',
          '5601377002717',
          '5601954000709',
          '5901617013177',
          '8003625026082',
          '8003625029243',
          '8003625073161',
          '8003625081470',
          '8003625091516',
          '8034115191065',
          '8410744008675',
          '8410744011590',
          '8411277205678',
        ],
      },
      {
        answer: 'Półsłodkie',
        eanCodeList: [
          '3263280102414',
          '3263280113762',
          '3263286350185',
          '3294381042026',
          '4006542073447',
          '4049366002927',
          '4049366003290',
          '4840472011274',
          '4840472011281',
          '4860004070173',
          '4860004070227',
          '5010134919135',
          '5010134919142',
          '5028267006943',
          '5600320460369',
          '5602445005500',
          '5908235955049',
          '5908235955063',
          '5997830309326',
          '5999074603666',
          '5999074609439',
          '5999074609651',
          '8003625011262',
          '8003625017042',
          '8003625082583',
          '8410261701202',
          '8410261703206',
          '8410702032452',
        ],
      },
      {
        answer: 'Słodkie',
        eanCodeList: [
          '3800007817444',
          '3800007819202',
          '3800007819219',
          '3800011414769',
          '4840472020498',
          '5601317007796',
          '5601377001789',
          '5602418000136',
          '5902241705865',
          '5902241712504',
          '5902241712528',
          '8006063003233',
          '8410744011934',
          '8410744011965',
        ],
      },
    ],
  },
  {
    id: 3,
    title: 'Cena',
    bgImg: img4cena,
    answers: [
      {
        answer: 'poniżej 20pln',
        eanCodeList: [
          '3800011414820',
          '5902241705865',
          '5902241712504',
          '5902241712528',
          '5908235955049',
          '5908235955063',
          '5999074609439',
          '5999074609651',
          '5999074609804',
          '8410261701202',
          '8410261703206',
        ],
      },
      {
        answer: '20-30 pln',
        eanCodeList: [
          '3249381004970',
          '3249381096302',
          '3263280102414',
          '3294381042026',
          '3308440053943',
          '3308440053950',
          '3500610137518',
          '3800007817444',
          '3800007819202',
          '3800007819219',
          '3800008911226',
          '3800008911325',
          '3800008919437',
          '3800008925285',
          '3800011414769',
          '4006542071337',
          '4006542073430',
          '4006542073447',
          '4008005630020',
          '4049366002927',
          '4049366003207',
          '4049366003290',
          '4840472011274',
          '4840472011281',
          '4840472019119',
          '4840472019126',
          '4840472020498',
          '4840472020900',
          '4860004070173',
          '4860004070227',
          '4860004073365',
          '4860038075304',
          '4860038075601',
          '5010134909518',
          '5010134916684',
          '5010134916714',
          '5010134917377',
          '5010134919135',
          '5010134919142',
          '5028267006943',
          '5600320460369',
          '5601317007796',
          '5601377001574',
          '5601377001581',
          '5601377001789',
          '5601377002717',
          '5601954000709',
          '5901617013177',
          '5998288509290',
          '5999074603642',
          '5999074603666',
          '7804462002250',
          '7804462002281',
          '8003625000907',
          '8003625001812',
          '8003625011255',
          '8003625013051',
          '8003625017042',
          '8003625020325',
          '8003625021056',
          '8003625029243',
          '8003625041757',
          '8003625048596',
          '8003625073161',
          '8003625080664',
          '8003625081470',
          '8003625082583',
          '8003625094029',
          '8006063003233',
          '8410702032452',
          '8410744006510',
          '8410744008675',
          '8410744011590',
          '8410744011934',
          '8410744011965',
          '8411277205654',
          '8411277205678',
          '9311043013584',
          '9311043032615',
          '9311043067549',
          '9311043081132',
        ],
      },
      {
        answer: 'powyżej 30 pln',
        eanCodeList: [
          '3113934001337',
          '3249381042798',
          '3249381050052',
          '3258691236339',
          '3258691612430',
          '3263280113762',
          '3263286350185',
          '3308440023380',
          '3800008165940',
          '4008005041697',
          '4014984016717',
          '4036505060443',
          '4049366003764',
          '4049366003788',
          '4860038075441',
          '4860038075502',
          '5010134919128',
          '5601250102213',
          '5602418000136',
          '5602445005500',
          '5997830309326',
          '8003625000518',
          '8003625003601',
          '8003625005612',
          '8003625011262',
          '8003625014836',
          '8003625026082',
          '8003625027515',
          '8003625033080',
          '8003625091516',
          '8007425000471',
          '8007425200017',
          '8034041270100',
          '8034115190006',
          '8034115191065',
          '8034115192925',
          '8034115194066',
          '8410261141039',
          '8410744010289',
        ],
      },
    ],
  },
  {
    id: 4,
    title: 'Okazja',
    bgImg: img5okazja,
    answers: [
      {
        answer: 'do relaksu',
        eanCodeList: [
          '3294381042026',
          '3800007819202',
          '3800007819219',
          '3800011414769',
          '3800011414820',
          '4049366002927',
          '4840472011274',
          '4840472011281',
          '4840472019119',
          '4840472019126',
          '5601317007796',
          '5601377001574',
          '5601377001581',
          '5601377001789',
          '5601377002717',
          '5601954000709',
          '5902241705865',
          '5902241712504',
          '5902241712528',
          '5908235955049',
          '5908235955063',
          '5998288509290',
          '5999074603642',
          '5999074603666',
          '5999074609439',
          '5999074609651',
          '5999074609804',
          '8003625011255',
          '8003625041757',
          '8003625073161',
          '8003625080664',
          '8003625081470',
          '8410261701202',
          '8410261703206',
          '8410744008675',
          '8410744011934',
          '8410744011965',
        ],
      },
      {
        answer: 'na prezent',
        eanCodeList: [
          '3113934001337',
          '3249381050052',
          '3258691236339',
          '3258691612430',
          '3308440023380',
          '3800008165940',
          '4014984016717',
          '4036505060443',
          '4049366003764',
          '4049366003788',
          '4840472020900',
          '4860038075441',
          '4860038075502',
          '5010134919128',
          '5601250102213',
          '5602418000136',
          '5602445005500',
          '5997830309326',
          '8003625000518',
          '8003625005612',
          '8003625014836',
          '8003625027515',
          '8003625033080',
          '8003625082583',
          '8006063003233',
          '8007425000471',
          '8007425200017',
          '8034041270100',
          '8034115191065',
          '8034115192925',
          '8034115194066',
          '8410744010289',
          '8411277205654',
          '8411277205678',
        ],
      },
      {
        answer: 'z przyjaciółmi',
        eanCodeList: [
          '3249381004970',
          '3249381042798',
          '3249381096302',
          '3263280102414',
          '3263280113762',
          '3263286350185',
          '3308440053943',
          '3308440053950',
          '3500610137518',
          '3800007817444',
          '3800008911226',
          '3800008911325',
          '3800008919437',
          '3800008925285',
          '4006542071337',
          '4006542073430',
          '4006542073447',
          '4008005041697',
          '4008005630020',
          '4049366003207',
          '4049366003290',
          '4840472020498',
          '4860004070173',
          '4860004070227',
          '4860004073365',
          '4860038075304',
          '4860038075601',
          '5010134909518',
          '5010134916684',
          '5010134916714',
          '5010134917377',
          '5010134919135',
          '5010134919142',
          '5028267006943',
          '5600320460369',
          '5901617013177',
          '7804462002250',
          '7804462002281',
          '8003625000907',
          '8003625001812',
          '8003625003601',
          '8003625011262',
          '8003625013051',
          '8003625017042',
          '8003625020325',
          '8003625021056',
          '8003625026082',
          '8003625029243',
          '8003625048596',
          '8003625091516',
          '8003625094029',
          '8034115190006',
          '8410261141039',
          '8410702032452',
          '8410744006510',
          '8410744011590',
          '9311043013584',
          '9311043032615',
          '9311043067549',
          '9311043081132',
        ],
      },
      {
        answer: 'musujące',
        eanCodeList: [
          '3113934001337',
          '4049366003290',
          '5902241712504',
          '5902241712528',
          '8003625011262',
          '8003625013051',
          '8003625017042',
          '8003625026082',
          '8003625082583',
          '8003625091516',
          '8006063003233',
          '8411277205654',
          '8411277205678',
        ],
      },
    ],
  },
  {
    id: 5,
    title: 'Kraj pochodzenia',
    bgImg: img6kraj,
    answers: [
      {
        answer: 'Włochy',
        eanCodeList: [
          '4006542073430',
          '4006542073447',
          '8003625000518',
          '8003625000907',
          '8003625001812',
          '8003625003601',
          '8003625005612',
          '8003625011255',
          '8003625011262',
          '8003625013051',
          '8003625014836',
          '8003625017042',
          '8003625020325',
          '8003625021056',
          '8003625026082',
          '8003625027515',
          '8003625029243',
          '8003625033080',
          '8003625041757',
          '8003625048596',
          '8003625073161',
          '8003625080664',
          '8003625081470',
          '8003625082583',
          '8003625091516',
          '8003625094029',
          '8006063003233',
          '8007425000471',
          '8007425200017',
          '8034041270100',
          '8034115190006',
          '8034115191065',
          '8034115192925',
          '8034115194066',
        ],
      },
      {
        answer: 'Francja',
        eanCodeList: [
          '3113934001337',
          '3249381004970',
          '3249381042798',
          '3249381050052',
          '3249381096302',
          '3258691236339',
          '3258691612430',
          '3263286350185',
          '3294381042026',
          '3308440023380',
          '3308440053943',
          '3308440053950',
          '3500610137518',
        ],
      },
      {
        answer: 'Gruzja',
        eanCodeList: [
          '4860004070173',
          '4860004070227',
          '4860004073365',
          '4860038075304',
          '4860038075441',
          '4860038075502',
          '4860038075601',
        ],
      },
      {
        answer: 'Hiszpania/Portugalia',
        eanCodeList: [
          '5600320460369',
          '5601250102213',
          '5601317007796',
          '5601377001574',
          '5601377001581',
          '5601377001789',
          '5601377002717',
          '5601954000709',
          '5602418000136',
          '5602445005500',
          '8410261141039',
          '8410261701202',
          '8410261703206',
          '8410702032452',
          '8410744006510',
          '8410744008675',
          '8410744010289',
          '8410744011590',
          '8410744011934',
          '8410744011965',
          '8411277205654',
          '8411277205678',
        ],
      },
      {
        answer: 'Bułgaria',
        eanCodeList: [
          '3800007817444',
          '3800007819202',
          '3800007819219',
          '3800008911226',
          '3800008911325',
          '3800008919437',
          '3800008925285',
          '3800011414769',
          '3800011414820',
          '5902241705865',
          '5902241712504',
          '5902241712528',
        ],
      },
      {
        answer: 'Nowy Świat',
        eanCodeList: [
          '3263280102414',
          '4008005630020',
          '5010134909518',
          '5010134916684',
          '5010134916714',
          '5010134917377',
          '5010134919128',
          '5010134919135',
          '5010134919142',
          '5028267006943',
          '5901617013177',
          '7804462002250',
          '7804462002281',
          '9311043013584',
          '9311043032615',
          '9311043067549',
          '9311043081132',
        ],
      },
      {
        answer: 'Węgry',
        eanCodeList: [
          '5997830309326',
          '5998288509290',
          '5999074603642',
          '5999074603666',
          '5999074609439',
          '5999074609651',
          '5999074609804',
        ],
      },
      {
        answer: 'Niemcy',
        eanCodeList: [
          '3263280113762',
          '4008005041697',
          '4014984016717',
          '4036505060443',
          '4049366002927',
          '4049366003207',
          '4049366003290',
          '4049366003764',
          '4049366003788',
        ],
      },
      {
        answer: 'Inne',
        eanCodeList: [
          '4006542071337',
          '4840472011274',
          '4840472011281',
          '4840472019119',
          '4840472019126',
          '4840472020498',
          '4840472020900',
          '5908235955049',
          '5908235955063',
        ],
      },
    ],
  },
];
*/
